var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
let Login = class Login extends Vue {
    password = '';
    email = '';
    login() {
        /*
         axios.get("/sanctum/csrf-cookie").then((_) => {
             axios.post('/login', {email: this.email.toLowerCase(), password: this.password}).then(
                 (response) => {
                     this.$store.commit('user');
                 }
             )
         }).finally(() => {
             this.checkingLogin = false;
          //   setTimeout(() => {
           //      this.$router.push("/dashboard");
          //   }, 2500);
 
         });
 
         */
        this.$store.commit('login', { email: this.email.toLowerCase(), password: this.password });
    }
    userHasRole(role) {
        return this.$store.getters.userHasRole(role);
    }
    created() {
        this.$store.state.monitor = false;
    }
};
Login = __decorate([
    Component({
        name: 'Login'
    })
], Login);
export default Login;
